export const testTwoLetters = 'вавававааваавааваавававав';
export const alphabet = 'абвгдеёжзийклмнопрстуфхцчшщъыьэюя';
export const alphabetEasy = 'авгеилмнопрстуфхцчшыэю';
export const alphabetHard = 'бдёжзйкщъья'; // пт?
export const easyPhrases = 'Привет, Филипп! Мне тут хорошо. И вам? Это мыло просто чума! Целую!';
export const forZoya = 'Привет, Зоя! Как дела? Чё делаешь?';
